var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{directives:[{name:"support-button",rawName:"v-support-button"}],staticClass:"help-button",attrs:{"is-primary":""}},[_c('img',{staticClass:"help-button__img",attrs:{"src":require('~/assets/img/icons/question-mark-white.svg'),"alt":"question"}}),_c('span',{staticClass:"help-button__text"},[_vm._v(_vm._s(_vm.$t('techSupport')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }